export const yenFmt = (n) => `¥${Number(n || 0).toLocaleString("ja-JP")}`;

export const SUB_STATUS = {
  trialing: { label: "トライアル中", tone: "text-amber-600 bg-amber-50 border-amber-200" },
  active: { label: "有効", tone: "text-emerald-600 bg-emerald-50 border-emerald-200" },
  past_due: { label: "支払い遅延", tone: "text-red-600 bg-red-50 border-red-200" },
  canceled: { label: "解約済み", tone: "text-gray-600 bg-gray-100 border-gray-200" },
};

export const limitLabel = (n) => (n >= 100000 ? "無制限" : `${n}`);
